<template>
    <div
        id="preview"
        class="card card-primary"
    >
        <div class="card-header">
            <div class="row">
                <div class="col col-md-12">
                    <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item">
                            <span
                                class="nav-link" 
                                :class="{'active': mode == 'android'}"
                                @click.stop.prevent="setMode('android')" 
                            >
                                <i class="fa fa-android" /> Android
                            </span>
                        </li>
                        <li class="nav-item">
                            <span
                                class="nav-link" 
                                :class="{'active': mode == 'windows'}"
                                @click.stop.prevent="setMode('windows')"
                            >
                                <i class="fa fa-windows" /> Windows 
                            </span>
                        </li>
                        <li class="nav-item">
                            <span
                                class="nav-link" 
                                :class="{'active': mode == 'macos'}"
                                @click.stop.prevent="setMode('macos')"
                            >
                                <i class="fa fa-apple" /> MacOS 
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div
            ref="preview"
            class="card-body nopadding"
        >
            <div
                v-if="mode == 'android'"
                class="android-preview-device"
            >
                <div class="android-device-notification">
                    <div class="android-notification-preview">
                        <div class="body">
                            <div class="header">
                                <img
                                    v-if="webBadge" 
                                    style="filter: brightness(30%) ; width: 16px; height: 16px; margin-right: 5px;"
                                    :src="webBadge"
                                >
                                <svg
                                    v-else
                                    class="android-google-chrome-icon"
                                    viewBox="0 0 1024 1024"
                                >
                                    <path
                                        stroke="inherit"
                                        d="M258.278 446.542l-146.532-253.802c93.818-117.464 238.234-192.74 400.254-192.74 187.432 0 351.31 100.736 440.532 251h-417.77c-7.504-0.65-15.092-1-22.762-1-121.874 0-224.578 
                                        83.644-253.722 196.542zM695.306 325h293.46c22.74 57.93 35.234 121.004 35.234 187 0 280.826-226.1 508.804-506.186 511.926l209.394-362.678c29.48-42.378 46.792-93.826 46.792-149.248 
                                        0-73.17-30.164-139.42-78.694-187zM326 512c0-102.56 83.44-186 186-186s186 83.44 186 186c0 102.56-83.44 186-186 186s-186-83.44-186-186zM582.182 764.442l-146.578 253.878c-246.532-36.884-435.604-249.516-435.604-506.32 
                                        0-91.218 23.884-176.846 65.696-251.024l209.030 362.054c41.868 89.112 132.476 150.97 237.274 150.97 24.3 0 47.836-3.34 70.182-9.558z"
                                    />
                                </svg>
                                <span class="app-name">
                                    Chrome • {{ site }}
                                </span>
                            </div>
                            <div class="preview-content">
                                <div class="flexjustified">
                                    <div>
                                        <p class="title">
                                            {{ header }}
                                        </p>
                                        <p class="preview-contents">
                                            {{ text }}
                                        </p>
                                    </div>
                                    <img
                                        v-if="webIcon"
                                        class="large-icon"
                                        :src="webIcon"
                                    >
                                </div>
                            </div>
                            <div
                                v-if="image"
                                style="height: 100px; background-size: cover; background-position: center center;"
                                :style="{'background-image': 'url('+image+')'}"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else-if="mode == 'windows'"
                class="windows-preview-device"
            >
                <div class="windows-preview os-preview">
                    <div class="windows-web-notification-preview">
                    <div style="display: table-row">
                        <div class="icon">
                            <img
                                v-if="webIcon"
                                class="default-site-icon"
                                :src="webIcon"
                            >
                        </div>
                        <div class="body">
                            <p class="message-title">
                                {{ header }}
                            </p>
                            <p class="message-body">
                                {{ text }}
                            </p>
                            <div class="origin">
                                <span class="origin">
                                    {{ site }}
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <div class="close-button">
                                <span>
                                    ×
                                </span>
                            </div>
                            <div class="gear-button">
                                <svg viewBox="0 0 24 24">
                                    <path
                                        d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,
                                        8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,
                                        6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,
                                        18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,
                                        18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
                                    />
                                </svg>
                            </div>
                        </div>
                        </div>
                        <img
                            v-if="image"
                            :src="image"
                            style="max-width: 100%;"
                        >
                    </div>
                </div>
            </div>
            <div
                v-else-if="mode == 'macos'"
                class="macos-preview-device"
            >
                <div class="macos-preview os-preview">
                    <div class="macos-web-notification-preview">
                        <div class="browser-icon">
                            <svg
                                class="macos-google-chrome-icon"
                                viewBox="0 0 48 48"
                            >
                                <circle
                                    cx="24"
                                    cy="24"
                                    r="19"
                                    fill="#4CAF50"
                                />
                                <path
                                    fill="#FFC107"
                                    d="M24 5v19l8 4-8.8 15h.8c10.5 0 19-8.5 19-19S34.5 5 24 5z"
                                />
                                <path
                                    fill="#F44336"
                                    d="M16 28l8-13h16.7C37.5 9 31.2 5 24 5c-6.7 0-12.6 3.5-16 8.8L16 28z"
                                />
                                <path 
                                    fill="#DD2C00" 
                                    d="M8 13.8L16 28l5-1"
                                />
                                <path
                                    fill="#F9A825"
                                    d="M40.6 15H24l-1.5 4.8"
                                />
                                <path
                                    fill="#558B2F"
                                    d="M23.2 43L32 28l-3.8-3.1"
                                />
                                <circle
                                    cx="24" 
                                    cy="24" 
                                    r="9" 
                                    fill="#FFF"
                                />
                                <circle
                                    cx="24"
                                    cy="24"
                                    r="7"
                                    fill="#2196F3"
                                />
                            </svg>
                        </div>
                        <div class="body">
                            <p class="message-title">
                                {{ header }}
                            </p>
                            <div class="origin">
                                <span class="origin">
                                    {{ site }}
                                </span>
                            </div>
                            <p class="message-body">
                                {{ text }}
                            </p>
                        </div>
                        <div class="icon">
                            <img
                                class="default-site-icon"
                                :src="webIcon"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WebpushPreview',
        props: {
            site: {
                type: String,
                default: '',
            },
            header: {
                type: String,
                default: '',
            },
            text: {
                type: String,
                default: '',
            },
            image: {
                type: String,
                default: '',
            },
            webBadge: {
                type: String,
                default: '',
            },
            webIcon: {
                type: String,
                default: '',
            },
            file: {
                type: Object,
                default: function(){ return {} },
            },
            imageSource: {
                type: String,
                default: '',
            },
            url: {
                type: String,
                default: '',
            },
        },
        data: function() {
            return { 
                mode: 'android',
            }
        },
        methods: {
            setMode: function(mode) {
                this.mode = mode; 
            }
        },
    }
</script>
